module.exports = __webpack_public_path__ + "static/media/computer.030e33e3.png";